import { areAnchorPropsOf } from '../../cta.models';
import { Btn, A } from './components';
import { IButtonA } from './components/A/buttonA.models';
import { IButtonProps } from './button.models';

export const Button: React.FC<IButtonProps> = (props) => {
  if (areAnchorPropsOf<IButtonA>(props)) {
    return <A {...props} />;
  }

  return <Btn {...props} />;
};

